import React from 'react';
import Logo from './Logo';

const SubscriptionTier = ({ tier, lookupKey, price, features, buttonText, isPopular }) => (
  <div className={`card w-full bg-base-100 shadow-xl ${isPopular ? 'border-4 border-primary' : 'border border-base-300'}`}>
    {isPopular && (
      <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
        <div className="badge badge-primary py-3 px-4 text-primary-content">Most Popular</div>
      </div>
    )}
    <div className="card-body">
      <div className="flex items-center gap-3">
        <Logo />
        <h2 className="card-title text-2xl">{tier}</h2>
      </div>
      
      <div className="mt-4">
        <p className="text-3xl font-bold">${price}<span className="text-base font-normal text-base-content/70">/month</span></p>
      </div>
      
      <div className="divider"></div>
      
      <ul className="space-y-2">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-success flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            <span>{feature}</span>
          </li>
        ))}
      </ul>
      
      <div className="card-actions justify-center mt-6">
        <form action="/create-checkout-session" method="POST" className="w-full">
          <input type="hidden" name="lookup_key" value={lookupKey} />
          <button 
            id="checkout-button" 
            type="submit" 
            className={`btn ${isPopular ? 'btn-primary' : 'btn-outline'} w-full`}
          >
            {buttonText || 'Subscribe Now'}
          </button>
        </form>
      </div>
    </div>
  </div>
);

export default SubscriptionTier;
